

	import {isInViewport} from "../util";

	export default {

		name: "hcdc-lazy-element",

		data() {
			return {
				isLoaded: false
			};
		},

		mounted() {
			window.addEventListener("scroll", this.onScroll, {passive: true});
			window.addEventListener("load", () => this.onScroll(), {once: true});
			window.addEventListener("hcdc:lazy-maybe-visible", this.onScroll, {passive: true});
			window.addEventListener("tns:update", this.onScroll, {passive: true});
		},

		render() {
			const children = this.$scopedSlots.default({
				instance: this,
				isLoaded: this.isLoaded
			});

			return children[0] || undefined;
		},

		methods: {

			onScroll() {
				if (!isInViewport(this.$el))
					return;

				window.removeEventListener("scroll", this.onScroll);
				window.removeEventListener("hcdc:lazy-maybe-visible", this.onScroll);
				window.removeEventListener("tns:update", this.onScroll);
				this.isLoaded = true;
			}

		}

	}

